import React from 'react'

import { ReasonIcon, ReasonRow, ReasonText } from './InboxPreview.styles'

interface InboxPreviewReasonProps {
  reason: React.ReactNode
}

export const InboxPreviewReason = ({ reason }: InboxPreviewReasonProps) => (
  <ReasonRow>
    <ReasonIcon aria-hidden />
    <ReasonText>{reason}</ReasonText>
  </ReasonRow>
)
